module.exports = __webpack_public_path__ + "images/avatars/female/10.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/10.svg
// module id = rrSb
// module chunks = 154